<template>
  <div class="addressManage">
    <myHeader :headerData="headerData"></myHeader>
    <mt-cell class="manageRow" :title="item.title" :key="item.platform" is-link :to="item.route" v-for="item in queryAddressData"></mt-cell>
  </div>
</template>

<script>
  import myHeader from '../components/header.vue';
  export default {
    name: 'addressManage',
    components: {
      myHeader
    },
    methods: {
        goAddress(item){
          this.$router.push({name:'addressList', query: {platform: item.platform}})
        }
    },
    data () {
      return {
        headerData: {
          name: '地址管理',
          isOut: true,
          save: false,
        },
        queryAddressData:[
          // {title:'礼品收货地址',route:'/addressList?platform=1'},
          {title:'预约外卖收货地址',route:'/addressList?platform=2'}
        ]
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/addressManage.vue